module.exports = __webpack_public_path__ + "img/returninquiry.51df129c.png";